<template>
  <component
    :is="asChild ? 'slot' : 'button'"
    :class="cn(buttonVariants({ variant, size }), className)"
    v-bind="$attrs"
    data-slot="button"
  >
    <slot />
  </component>
</template>

<script>
const buttonVariants = (options) => {
  const base = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
  
  const variants = {
    variant: {
      default: "bg-black text-white focus-visible:ring-gray-500 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100",
      destructive: "bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500 dark:bg-red-700 dark:hover:bg-red-800",
      outline: "border border-gray-300 bg-[#e5e5e580] text-gray-900 focus-visible:ring-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-white dark:hover:bg-gray-800",
      secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200 focus-visible:ring-gray-400 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700",
      ghost: "hover:bg-gray-100 text-gray-900 focus-visible:ring-gray-400 dark:hover:bg-gray-800 dark:text-white",
      link: "text-gray-900 underline-offset-4 hover:underline focus-visible:ring-gray-400 dark:text-white"
    },
    size: {
      default: "h-9 px-4 py-2 has-[>svg]:px-3",
      sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
      lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
      icon: "size-9 rounded-md"
    }
  }

  let classes = [base]
  
  if (options.variant && variants.variant[options.variant]) {
    classes.push(variants.variant[options.variant])
  }
  
  if (options.size && variants.size[options.size]) {
    classes.push(variants.size[options.size])
  }
  
  if (options.className) {
    classes.push(options.className)
  }
  
  return classes.join(' ')
}

// Simple class concatenation utility
const cn = (...classes) => {
  return classes.filter(Boolean).join(' ')
}

export default {
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'destructive', 'outline', 'secondary', 'ghost', 'link'].includes(value)
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'sm', 'lg', 'icon'].includes(value)
    },
    asChild: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },
  setup() {
    return {
      buttonVariants,
      cn
    }
  }
}
</script>